import React, { Component } from 'react';
import { Modal, Icon, Tab } from 'semantic-ui-react';
//import { Scrollbars } from 'react-custom-scrollbars-2';
//import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import cx from 'classnames';
import {
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  //InfiniteLoader,
  List,
  WindowScroller
} from 'react-virtualized';
import 'react-virtualized/styles.css';
import { observer, inject } from 'mobx-react';
import WithRouter from '../Extensions/WithRouter';
import SecurityDetailModal from './SecurityDetailModal';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import Loader from '../Loader/Loader';
import { convertPropertiesToCamelCase } from '../../utils/shared';

class SecurityRiskUpdatedModal extends Component {
  cache = new CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: 30,
  });

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      isLoading: false,
      added: [],
      declined: [],
      activeTab: 0,
      scrollToIndex: -1,
      isOpenMSD: false,
      cveData: {},
      selectedCode: '',
    };
    this.clearScrollToIndex = this.clearScrollToIndex.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleSecurityDetailModal = this.handleSecurityDetailModal.bind(this);
    this.handleMSDClose = this.handleMSDClose.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.modal_popup_wrap .modal_popup .title  span', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { isOpenMSU } = this.props;
    if (prevProps.isOpenMSU !== isOpenMSU) {
      if (isOpenMSU) {
        this.getResultsBySecurity();
      } else {
        this.setState({
          name: '',
          added: [],
          declined: [],
          isLoading: false,
          activeTab: 0,
          scrollToIndex: -1,
          isOpenMSD: false,
          cveData: {},
          selectedCode: '',
        });
      }
    }
  }

  componentWillUnmount() {
  }

  handleSecurityDetailModal(e, value) {
    const data = {
      security_name: value,
    };
    this.setState({
      isLoading: true,
    });

    api
      .getComponentSecurityDetail(data)
      .then((response) => {
        this.setState({
          cveData: response.response,
          selectedCode: value,
          isOpenMSD: true,
          isLoading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
        });
      });
  }

  handleMSDClose() {
    this.setState({
      isOpenMSD: false,
    });
  }

  getResultsBySecurity = () => {
    const { reportId } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getResultsBySecurity(reportId)
        .then((response) => {
          const data = convertPropertiesToCamelCase(response.response);
          this.setState({
            isLoading: false,
            name: data.name,
            added: data.added,
            declined: data.declined,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    });

  };

  handleTabChange = (e, { activeIndex }) => {
    this.setState({
      activeTab: activeIndex,
      scrollToIndex: -1,
    });
  };

  clearScrollToIndex() {
    this.setState({
      scrollToIndex: -1
    });
  }

  closeModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  renderRow = ({
    index, key, style, parent, data
  }) => {
    const entity = data[index];
    const entityKey = Object.keys(entity)[0];
    const entityValue = entity[entityKey];

    return (
      <CellMeasurer
        key={key}
        cache={this.cache}
        columnIndex={0}
        rowIndex={index}
        parent={parent}
      >
        <div
          style={style}
          className={cx('bullet', {
            red: entityValue === 'critical',
            orange: entityValue === 'high',
            cheese: entityValue === 'medium',
            yellow: entityValue === 'low',
          })}
        >
          <span
            className="has_link"
            onClick={(e) => {
              return this.handleSecurityDetailModal(e, entityKey);
            }}
            onKeyUp={(e) => {
              return this.handleSecurityDetailModal(e, entityKey);
            }}
          >
            {entityKey}
          </span>
        </div>
      </CellMeasurer>
    );
  };

  render() {
    const {
      isLoading,
      name,
      added,
      declined,
      activeTab,
      scrollToIndex,
      isOpenMSD,
      cveData,
      selectedCode
    } = this.state;

    const { translate, isOpenMSU } = this.props;

    const panes = [
      {
        menuItem: `${translate('modal.title.discorverd_security_risks')} (${added.length})`,
        render: () => {
          return (
            <Tab.Pane>
              {added.length !== 0 && (
                <div className="popup_content_item">
                  <div className="item_content">
                    <WindowScroller
                      onScroll={this.clearScrollToIndex}
                    >
                      {() => {
                        return (
                          <AutoSizer>
                            {() => {
                              return (
                                <List
                                  width={500}
                                  height={300}
                                  deferredMeasurementCache={this.cache}
                                  rowCount={added.length}
                                  rowHeight={30}
                                  rowRenderer={(props) => { return this.renderRow({ ...props, data: added }); }}
                                  scrollToIndex={scrollToIndex}
                                />
                              );
                            }}
                          </AutoSizer>
                        );
                      }}
                    </WindowScroller>
                  </div>
                </div>
              )}
            </Tab.Pane>
          );
        },
      },
      {
        menuItem: `${translate('modal.title.rejected_security_risks')} (${declined.length})`,
        render: () => {
          return (
            <Tab.Pane>
              {declined.length !== 0 && (
                <div className="popup_content_item">
                  <div className="item_content">
                    <WindowScroller
                      onScroll={this.clearScrollToIndex}
                    >
                      {() => {
                        return (
                          <AutoSizer>
                            {() => {
                              return (
                                <List
                                  width={500}
                                  //height={this.cache.rowHeight({ index: 0 }) * declined.length}
                                  height={300}
                                  deferredMeasurementCache={this.cache}
                                  rowCount={declined.length}
                                  rowHeight={30}
                                  rowRenderer={(props) => { return this.renderRow({ ...props, data: declined }); }}
                                  scrollToIndex={scrollToIndex}
                                />
                              );
                            }}
                          </AutoSizer>
                        );
                      }}
                    </WindowScroller>
                  </div>
                </div>
              )}
            </Tab.Pane>
          );
        },
      },
    ];

    const getModalContent = () => {
      if (isLoading) {
        return (
          <div className="modal_popup_wrap move_file_wrap">
            <div className="modal_popup_box move_file_box">
              <div className="modal_popup move_file">
                <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                  <Loader />
                </div>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div className="modal_popup_wrap">
          <div className="modal_popup_box">
            <div className="modal_popup security_info">
              <h2 className="title">
                <Icon className="file outline" />
                <span>
                  {name}
                </span>
                <a className="close_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                  <img src={closeBtn} alt="" />
                </a>
              </h2>
              <div className="popup_content" style={{ height: 300, overflowX: 'hidden' }}>
                <Tab panes={panes} activeIndex={activeTab} onTabChange={this.handleTabChange} />
              </div>
              <div className="button_wrap">
                <a onClick={this.closeModal} onKeyUp={this.closeModal} className="center_button">{translate('modal.button.close')}</a>
              </div>
            </div>
          </div>
        </div>
      );
    };
    return (
      <Modal open={isOpenMSU} onClose={this.closeModal}>
        {getModalContent()}
        <SecurityDetailModal
          isOpenMSD={isOpenMSD}
          closeModal={this.handleMSDClose}
          cveData={cveData}
          selectedCode={selectedCode}
        />
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(SecurityRiskUpdatedModal)));
